export class UserNotificationPreferencesDTO {
    constructor(
        public venueId: string,
        public bookingRequests: boolean
    ) { }
}
